// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitleBar_pageTitle__JOOXC"};